/**
 * AJW internal users are represented as company id 2 (see legacy DataSearchBar,
 * OrdersActions, Full.js route permissions, etc.). Use loose equality so numeric
 * or string ids from the API both match.
 */
export function isInternalAjwUser(
  user: Record<string, unknown> | null | undefined,
): boolean {
  if (!user || typeof user !== "object") {
    return false;
  }
  const u = user as {
    companyId?: unknown;
    company?: { id?: unknown } | null;
  };
  const rootId = u.companyId;
  const nestedId = u.company?.id;
  return rootId == 2 || nestedId == 2;
}
